import styled from 'styled-components';
import { primary, neutral } from '../../style/colors';

export const ResultsContainer = styled.div`
  padding: 16px 20px;
  max-width: 1800px;
  margin: 0 auto;
  position: relative;
  min-height: 400px;
  overflow-x: hidden;

  @media (max-width: 1024px) {
    padding: 12px;
  }
`;

export const ResultsList = styled.div`
  opacity: ${(props) => (props.isLoading ? 0.6 : 1)};
  transition: opacity 0.3s ease;
  pointer-events: ${(props) => (props.isLoading ? 'none' : 'all')};

  > * {
    animation: fadeIn 0.3s ease forwards;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const LoadingOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, ${primary[500]} 0%, ${primary[600]} 50%, ${primary[500]} 100%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  z-index: 10;
  border-radius: 2px;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  color: ${neutral[500]};

  i {
    font-size: 64px;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    margin: 0;
  }
`;

export const LoadingState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  color: ${neutral[500]};

  i {
    font-size: 48px;
    animation: spin 1s linear infinite;
  }

  p {
    font-size: 16px;
    margin-top: 15px;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`;
